export const FILE_SIZE = 30
export const FILE_TYPES = ["jpg","jpeg","png","pdf","doc","docx", "document", "msword"]
export const MULTIPLE_SIZE = 10
export const FILE_ACCEPTED = ".jpg, .jpeg, .png, .pdf, .doc, .docx"